export default __webpack_public_path__ + "static/bg-end-5620bed5af64765051c51e40c025ac70.png";